"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSyncMessage = sendSyncMessage;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getApiUrl = () => process.env.REACT_APP_CHAT_AGENT_DOMAIN || 'http://localhost:8080';
const isMockEnabled = () => process.env.REACT_APP_DEVELOPMENT_MODE === 'enabled';
const fetchMock = async () => {
  const res = await fetch('/chatSyncMock.json');
  const data = await res.json();
  return new Response(JSON.stringify(data), {
    status: 200,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
async function sendSyncMessage(message, sessionId) {
  const xPromptVersion = process.env.REACT_APP_X_PROMPT_VERSION;
  const headers = process.env.REACT_APP_TEAM ? {
    team: process.env.REACT_APP_TEAM
  } : {};
  const userKey = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".LastAuthUser"));
  if (userKey) {
    const jwt = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".").concat(userKey, ".idToken"));
    if (jwt) headers.Authorization = "Bearer ".concat(jwt);
  }
  if (isMockEnabled()) return fetchMock();
  const body = {
    message
  };
  if (sessionId) body.thread_id = sessionId;
  const response = await fetch("".concat(getApiUrl(), "/v1/ai/chat/sync"), {
    method: 'POST',
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      'Content-Type': 'application/json',
      'x-prompt-version': xPromptVersion
    }),
    body: JSON.stringify({
      body
    })
  });
  if (!response.ok) {
    throw new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
  }
  return response;
}